import {
	createStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const styles = (theme: Theme) => {
	return createStyles({
		circularProgressIcon_wrapper: {
			transform: 'rotate(-90deg)',
		},
		circularProgressIcon_finishedCircle: {
			color: theme.palette.primary.main,
			stroke: 'currentColor',
		},
		circularProgressIcon_unfinishedCircle: {
			color: theme.palette.grey[300],
			stroke: 'currentColor',
		},
	});
}

export default styles;
